import React from 'react';
import OrderSummary from '@/containers/orderSummary';
import Bubble from '@/components/bubble';
import FormTemplate from '@/components/formTemplate';
import Page from '@/components/pageLayout';
import { grid } from '@/constants/grid';
import FormFake from '@/components/fakes/formPagesFake';
import ShoppingCartFake from '@/components/fakes/shoppingCartFake';
import LoginCard from '@/components/loginCard';
import { goLoginUrlWithRedirect } from '@/utils/common';
import { DevTool } from '@hookform/devtools';

const FormLayout = ({
  onSubmit,
  children,
  control,
  showErrorBubble,
  textBubble,
  loaded,
  shoppingCart,
  loadingShoppingCart,
  loadingButtonShoppingCart = false,
  pageId,
  nextStepsText,
  buttonCustomError = '',
  formFake = <FormFake />,
  shoppingCartFake = <ShoppingCartFake />,
  urlLoginCardRedirect,
  columnForm = false,
}) => {
  return (
    <>
      <Page pageId={pageId} columnForm={columnForm}>
        <div className="form-layout container">
          <form className="row" onSubmit={onSubmit}>
            <div
              className={`col-lg-8 col-sm-7 col-xs-12 ${
                columnForm ? 'col-form-fields--column-form' : 'col-form-fields'
              }`}
            >
              {!loaded && formFake}
              {!loaded && columnForm && shoppingCartFake}
              {loaded && (
                <>
                  {urlLoginCardRedirect && (
                    <FormTemplate>
                      <LoginCard
                        className="login-card-container"
                        text="Si eres cliente identifícate"
                        label="Soy cliente"
                        onClick={() => {
                          goLoginUrlWithRedirect(urlLoginCardRedirect);
                        }}
                      />
                    </FormTemplate>
                  )}

                  {showErrorBubble && (
                    <FormTemplate>
                      <Bubble
                        className="form__bubble"
                        textBubble={textBubble}
                        cyData="form__bubble"
                      />
                    </FormTemplate>
                  )}
                  {children}
                  {columnForm && (
                    <OrderSummary
                      className="order-summary"
                      control={control}
                      shoppingCart={shoppingCart}
                      loadingShoppingCart={loadingShoppingCart}
                      loadingButtonShoppingCart={loadingButtonShoppingCart}
                      nextStepsText={nextStepsText}
                      buttonCustomError={buttonCustomError}
                    />
                  )}
                </>
              )}
            </div>
            <div className="col-lg-4 col-sm-5 col-xs-12 order-summary">
              {!columnForm && !loaded && shoppingCartFake}
              {!columnForm && loaded && (
                <OrderSummary
                  className="order-summary"
                  control={control}
                  shoppingCart={shoppingCart}
                  loadingShoppingCart={loadingShoppingCart}
                  loadingButtonShoppingCart={loadingButtonShoppingCart}
                  nextStepsText={nextStepsText}
                  buttonCustomError={buttonCustomError}
                />
              )}
            </div>
          </form>
          {loaded && <DevTool control={control} />}
        </div>
      </Page>
      <style jsx>
        {`
          .form-layout {
            margin-top: 22px;
          }
          :global(.order-summary) {
            position: sticky;
            top: 0;
          }
          :global(.login-card-container) {
            margin-bottom: 12px;
          }
          :global(.form__bubble) {
            margin-bottom: 22px;
          }
          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .col-form-fields--column-form {
              grid-column-start: 4;
              grid-column-end: 10;
            }
          }
          @media screen and (min-width: ${grid.breakpoint_md}px) {
            .col-form-fields--column-form {
              grid-column-start: 4;
              grid-column-end: 10;
            }
          }
          @media screen and (min-width: ${grid.breakpoint_lg}px) {
            .col-form-fields--column-form {
              grid-column-start: 5;
              grid-column-end: 9;
            }
            .col-form-fields {
              grid-column-start: 2;
              grid-column-end: 8;
            }
            .col-form-order-summary {
              grid-column-start: 8;
              grid-column-end: 12;
            }
          }
        `}
      </style>
    </>
  );
};
export default FormLayout;
